module.exports = __webpack_public_path__ + "img/ics_o_commodity_v2.536e86a1.svg";